import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useStateContext } from "../Contexts/ContextProvider";
import { useBaseUrl } from "../Contexts/BaseUrlContext";

const Header = ({ category, title }) => {
  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext();
  const { baseUrl } = useBaseUrl();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }

    console.log("App component mounted");
  }, []);

  const navigation = useNavigate();
  useEffect(() => {
    axios
      .post(
        `${baseUrl}auth.php`,
        {
          action: "auth-check",
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      )
      .then((response) => {
        console.log("Auth Response:", response.data);

        if (response.data.access === false) {
          navigation("/login");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const dark = {
    color: "white",
    backgroundColor: "#20232A", // Dark background color
  };

  return (
    <div style={currentMode === "Dark" ? dark : {}} className="mb-10">
      <p
        className={currentMode === "Dark" ? "text-white-400" : "text-gray-400"}
      >
        {category}
      </p>
      <p
        className={
          currentMode === "Dark"
            ? "text-3xl font-extrabold tracking-tight text-white-400"
            : "text-3xl font-extrabold tracking-tight text-slate-900"
        }
      >
        {title}
      </p>
    </div>
  );
};

export default Header;
